// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** U.S. Virgin Islands */
const VI: PhoneNumberData = [1, 'VI', 10, format0, /^(?:340)/];

export default VI;
